import React from 'react';
import LotSearchItem from "./LotSearchItem";
import LotSearchInfo from "./LotSearchInfo";
import PropTypes from "prop-types";

export default class LotSearchContent extends React.PureComponent {

    render() {
        return (
            <div
                className={`listing-items listing__items ${this.props.isGridView ? 'is-grid grid grid--12' : '' }`}>
                {this.props.items.map(item =>
                    <LotSearchItem item={item} key={item.id}/>
                )}
            </div>
        );
    }
}

LotSearchContent.propTypes = {
    items: PropTypes.array.isRequired,
    isGridView: PropTypes.bool.isRequired,
};




// WEBPACK FOOTER //
// ./app/components/lots-search/js/LotSearchContent.js